/* eslint-disable arrow-body-style */
import React, { Component } from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { fatcaCrsAction } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import {
  PaddedContainer, Label, Input, Textarea, Notes,
  FormElementContainer, Options, SimpleSelectBox,
} from 'components';
import { FORM_KEYS } from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';
import validation from 'shared/validations';
import utils from 'shared/helpers/utils';

class Fatca extends Component {
  onElementChange = ({ target: { name, value } }) => {
    const { onUpdateFatca } = this.props;
    onUpdateFatca(name, value);
  }

  onBoolChange = ({ target: { name, value, id } }) => {
    const { intl, onUpdateFatca, onClearQ2toQ6 } = this.props;
    const { getStringAfterSpecialChar } = utils;
    const selected = getStringAfterSpecialChar(id, '_');
    onUpdateFatca(name, selected);

    /** clear questions 2 - 6 and the dynamic fields */
    if (name === 'fatcaQ1' && value === intl.formatMessage({ id: 'yes' })) onClearQ2toQ6();
  }

  onHandleSelect = (name, value) => {
    if (name && value) this.props.onUpdateFatca(name, value);
  }

  render() {
    const {
      intl, question1, question2, question3, question4, question5, question6,
      fatcaQ2state, fatcaQ2city, q3Address, q3UsPhone, q4Address,
      q5Beneficiary, q5Nationality, q6NameOfPerson, q6Nationality, q6Address, q6UsPhone,
      isSubmitClicked,
    } = this.props;
    const { FATCA } = FORM_KEYS;
    const { fatcaCrsOptions, nationalities } = arrOptions;
    const {
      fatcaSchema: {
        fatcaQ1Schema, fatcaQ2Schema, fatcaQ3Schema,
        fatcaQ4Schema, fatcaQ5Schema, fatcaQ6Schema,
      },
      getErrorMessages,
    } = validation;

    const elementValidation = {
      [FATCA.FATCA_Q1]: {
        isValid: fatcaQ1Schema(intl).isValidSync({ fatcaQ1: question1 }),
        errorMessage: getErrorMessages({ fatcaQ1: question1 }, fatcaQ1Schema(intl)),
      },
      [FATCA.FATCA_Q2]: {
        isValid: fatcaQ2Schema(intl, FATCA.FATCA_Q2, question1, question2).isValidSync({ fatcaQ2: question2 }),
        errorMessage: getErrorMessages({ fatcaQ2: question2 }, fatcaQ2Schema(intl, FATCA.FATCA_Q2, question1, question2)),
      },
      [`${FATCA.FATCA_Q2}${FATCA.STATE}`]: {
        isValid: fatcaQ2Schema(intl, `${FATCA.FATCA_Q2}${FATCA.STATE}`, question1, question2).isValidSync({ fatcaQ2state }),
        errorMessage: getErrorMessages({ fatcaQ2state }, fatcaQ2Schema(intl, `${FATCA.FATCA_Q2}${FATCA.STATE}`, question1, question2)),
      },
      [`${FATCA.FATCA_Q2}${FATCA.CITY}`]: {
        isValid: fatcaQ2Schema(intl, `${FATCA.FATCA_Q2}${FATCA.CITY}`, question1, question2).isValidSync({ fatcaQ2city }),
        errorMessage: getErrorMessages({ fatcaQ2city }, fatcaQ2Schema(intl, `${FATCA.FATCA_Q2}${FATCA.CITY}`, question1, question2)),
      },

      [FATCA.FATCA_Q3]: {
        isValid: fatcaQ3Schema(intl, FATCA.FATCA_Q3, question1, question3).isValidSync({ fatcaQ3: question3 }),
        errorMessage: getErrorMessages({ fatcaQ3: question3 }, fatcaQ3Schema(intl, FATCA.FATCA_Q3, question1, question3)),
      },
      [`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`]: {
        isValid: fatcaQ3Schema(intl, `${FATCA.FATCA_Q3}${FATCA.ADDRESS}`, question1, question3).isValidSync({ fatcaQ3address: q3Address }),
        errorMessage: getErrorMessages({ fatcaQ3address: q3Address }, fatcaQ3Schema(intl, `${FATCA.FATCA_Q3}${FATCA.ADDRESS}`, question1, question3)),
      },
      [`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`]: {
        isValid: fatcaQ3Schema(intl, `${FATCA.FATCA_Q3}${FATCA.US_PHONE}`, question1, question3).isValidSync({ fatcaQ3usPhone: q3UsPhone }),
        errorMessage: getErrorMessages({ fatcaQ3usPhone: q3UsPhone }, fatcaQ3Schema(intl, `${FATCA.FATCA_Q3}${FATCA.US_PHONE}`, question1, question3)),
      },

      [FATCA.FATCA_Q4]: {
        isValid: fatcaQ4Schema(intl, FATCA.FATCA_Q4, question1, question4).isValidSync({ fatcaQ4: question4 }),
        errorMessage: getErrorMessages({ fatcaQ4: question4 }, fatcaQ4Schema(intl, FATCA.FATCA_Q4, question1, question4)),
      },
      [`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`]: {
        isValid: fatcaQ4Schema(intl, `${FATCA.FATCA_Q4}${FATCA.ADDRESS}`, question1, question4).isValidSync({ fatcaQ4address: q4Address }),
        errorMessage: getErrorMessages({ fatcaQ4address: q4Address }, fatcaQ4Schema(intl, `${FATCA.FATCA_Q4}${FATCA.ADDRESS}`, question1, question4)),
      },

      [FATCA.FATCA_Q5]: {
        isValid: fatcaQ5Schema(intl, FATCA.FATCA_Q5, question1, question5).isValidSync({ fatcaQ5: question5 }),
        errorMessage: getErrorMessages({ fatcaQ5: question5 }, fatcaQ5Schema(intl, FATCA.FATCA_Q5, question1, question5)),
      },
      [`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`]: {
        isValid: fatcaQ5Schema(intl, `${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`, question1, question5).isValidSync({ fatcaQ5beneficiary: q5Beneficiary }),
        errorMessage: getErrorMessages({ fatcaQ5beneficiary: q5Beneficiary }, fatcaQ5Schema(intl, `${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`, question1, question5)),
      },
      [`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`]: {
        isValid: fatcaQ5Schema(intl, `${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`, question1, question5).isValidSync({ fatcaQ5nationality: q5Nationality }),
        errorMessage: getErrorMessages({ fatcaQ5nationality: q5Nationality }, fatcaQ5Schema(intl, `${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`, question1, question5)),
      },

      [FATCA.FATCA_Q6]: {
        isValid: fatcaQ6Schema(intl, FATCA.FATCA_Q6, question1, question6).isValidSync({ fatcaQ6: question6 }),
        errorMessage: getErrorMessages({ fatcaQ6: question6 }, fatcaQ6Schema(intl, FATCA.FATCA_Q6, question1, question6)),
      },
      [`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`]: {
        isValid: fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`, question1, question6).isValidSync({ fatcaQ6name: q6NameOfPerson }),
        errorMessage: getErrorMessages({ fatcaQ6name: q6NameOfPerson }, fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`, question1, question6)),
      },
      [`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`]: {
        isValid: fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`, question1, question6).isValidSync({ fatcaQ6nationality: q6Nationality }),
        errorMessage: getErrorMessages({ fatcaQ6nationality: q6Nationality }, fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`, question1, question6)),
      },
      [`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`]: {
        isValid: fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.ADDRESS}`, question1, question6).isValidSync({ fatcaQ6address: q6Address }),
        errorMessage: getErrorMessages({ fatcaQ6address: q6Address }, fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.ADDRESS}`, question1, question6)),
      },
      [`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`]: {
        isValid: fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.US_PHONE}`, question1, question6).isValidSync({ fatcaQ6usPhone: q6UsPhone }),
        errorMessage: getErrorMessages({ fatcaQ6usPhone: q6UsPhone }, fatcaQ6Schema(intl, `${FATCA.FATCA_Q6}${FATCA.US_PHONE}`, question1, question6)),
      },
    };

    /** parse options yes/no */
    const modifyOptions = (name) => {
      if (!Array.isArray(fatcaCrsOptions)) return null;
      const newArr = [];
      
      fatcaCrsOptions.forEach((item) => {
        newArr.push({
          id: `${name}_${item.id}`,
          label: item.label,
        });
      });

      return newArr;
    };

    // const lowerCase = (val) => {
    //   if (!val) return null;
    //   return val.toLowerCase();
    // };

    const translateAnswer = (str) => {
      return str ? intl.formatMessage({ id: str.toLowerCase() }) : str;
    };

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        {/* <p>{intl.formatMessage({ id: 'fatcaCrsQuestionnaires.notes' }) }</p> */}
        <FormElementContainer>
          <Label noFontWeight label={intl.formatMessage({ id: 'fatca.q1' })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={FATCA.FATCA_Q1}
            optionList={modifyOptions(FATCA.FATCA_Q1)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question1)}
            isValid={elementValidation[FATCA.FATCA_Q1].isValid}
            errorMessage={elementValidation[FATCA.FATCA_Q1].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        { translateAnswer(question1) === intl.formatMessage({ id: 'yes' }) && (
          <Notes
            msg={<FormattedHTMLMessage id="fatca.q1.yes" />}
            isInfo={false}
          />
        )}

        {(translateAnswer(question1) === intl.formatMessage({ id: 'no' }) || question1 === `${FATCA.FATCA_Q1}_no`) && (
          <section>
            <p>{intl.formatMessage({ id: 'fatcaCrsQuestionnaires.notes2' }) }</p>

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'fatca.q2' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                useLabel
                name={FATCA.FATCA_Q2}
                optionList={modifyOptions(FATCA.FATCA_Q2)}
                onCheckMarkChange={this.onBoolChange}
                defaultValue={translateAnswer(question2)}
                isValid={elementValidation[FATCA.FATCA_Q2].isValid}
                errorMessage={elementValidation[FATCA.FATCA_Q2].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(translateAnswer(question2) === intl.formatMessage({ id: 'yes' }) || question2 === `${FATCA.FATCA_Q2}_yes`) && (
              <>
                <p>{intl.formatMessage({ id: 'fatca.provide' })}</p>
                <FormElementContainer isWithPadding isLightBg>
                  <Input
                    label={intl.formatMessage({ id: 'fatca.state' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.state' }).toLowerCase()}`}
                    name={`${FATCA.FATCA_Q2}${FATCA.STATE}`}
                    onInputChange={this.onElementChange}
                    value={fatcaQ2state}
                    isValid={elementValidation[`${FATCA.FATCA_Q2}${FATCA.STATE}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q2}${FATCA.STATE}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <Input
                    label={intl.formatMessage({ id: 'fatca.city' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.city' }).toLowerCase()}`}
                    name={`${FATCA.FATCA_Q2}${FATCA.CITY}`}
                    onInputChange={this.onElementChange}
                    value={fatcaQ2city}
                    isValid={elementValidation[`${FATCA.FATCA_Q2}${FATCA.CITY}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q2}${FATCA.CITY}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </>
            )}

            <FormElementContainer>
              <Label
                label={(
                  <FormattedHTMLMessage id="fatca.q3" />
            )}
              />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                useLabel
                name={FATCA.FATCA_Q3}
                optionList={modifyOptions(FATCA.FATCA_Q3)}
                onCheckMarkChange={this.onBoolChange}
                defaultValue={translateAnswer(question3)}
                isValid={elementValidation[FATCA.FATCA_Q3].isValid}
                errorMessage={elementValidation[FATCA.FATCA_Q3].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(translateAnswer(question3) === intl.formatMessage({ id: 'yes' }) || question3 === `${FATCA.FATCA_Q3}_yes`) && (
              <>
                <p>{intl.formatMessage({ id: 'fatca.provide' })}</p>
                <FormElementContainer isWithPadding isLightBg>
                  <Textarea
                    label={intl.formatMessage({ id: 'fatca.detailedAddress' })}
                    placeholder={intl.formatMessage({ id: 'fatca.detailedAddress.placeholder' })}
                    name={`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`}
                    onInputChange={this.onElementChange}
                    value={q3Address}
                    isValid={elementValidation[`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <Input
                    label={intl.formatMessage({ id: 'fatca.usPhone' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.usPhone' })}`}
                    name={`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`}
                    onInputChange={this.onElementChange}
                    value={q3UsPhone}
                    isValid={elementValidation[`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </>
            )}

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'fatca.q4' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                useLabel
                name={FATCA.FATCA_Q4}
                optionList={modifyOptions(FATCA.FATCA_Q4)}
                onCheckMarkChange={this.onBoolChange}
                defaultValue={translateAnswer(question4)}
                isValid={elementValidation[FATCA.FATCA_Q4].isValid}
                errorMessage={elementValidation[FATCA.FATCA_Q4].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(translateAnswer(question4) === intl.formatMessage({ id: 'yes' }) || question4 === `${FATCA.FATCA_Q4}_yes`) && (
              <>
                <p>{intl.formatMessage({ id: 'fatca.provide' })}</p>
                <FormElementContainer isWithPadding isLightBg>
                  <Textarea
                    label={intl.formatMessage({ id: 'fatca.detailedAddress' })}
                    placeholder={intl.formatMessage({ id: 'fatca.detailedAddress.placeholder' })}
                    name={`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`}
                    onInputChange={this.onElementChange}
                    value={q4Address}
                    isValid={elementValidation[`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </>
            )}

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'fatca.q5' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                useLabel
                name={FATCA.FATCA_Q5}
                optionList={modifyOptions(FATCA.FATCA_Q5)}
                onCheckMarkChange={this.onBoolChange}
                defaultValue={translateAnswer(question5)}
                isValid={elementValidation[FATCA.FATCA_Q5].isValid}
                errorMessage={elementValidation[FATCA.FATCA_Q5].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(translateAnswer(question5) === intl.formatMessage({ id: 'yes' }) || question5 === `${FATCA.FATCA_Q5}_yes`) && (
              <>
                <p>{intl.formatMessage({ id: 'fatca.provide' })}</p>
                <FormElementContainer isWithPadding isLightBg>
                  <Input
                    label={intl.formatMessage({ id: 'fatca.beneficiary' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.beneficiary' }).toLowerCase()}`}
                    name={`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`}
                    onInputChange={this.onElementChange}
                    value={q5Beneficiary}
                    isValid={elementValidation[`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <SimpleSelectBox
                    label={intl.formatMessage({ id: 'clientDetails.nationality' })}
                    placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.nationality' }).toLowerCase()}`}
                    dataList={nationalities}
                    name={`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`}
                    onSelect={this.onHandleSelect}
                    defaultValue={q5Nationality}
                    isSearchInputDisabled={false}
                    isValid={elementValidation[`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </>
            )}

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'fatca.q6' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                useLabel
                name={FATCA.FATCA_Q6}
                optionList={modifyOptions(FATCA.FATCA_Q6)}
                onCheckMarkChange={this.onBoolChange}
                defaultValue={translateAnswer(question6)}
                isValid={elementValidation[FATCA.FATCA_Q6].isValid}
                errorMessage={elementValidation[FATCA.FATCA_Q6].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(translateAnswer(question6) === intl.formatMessage({ id: 'yes' }) || question6 === `${FATCA.FATCA_Q6}_yes`) && (
              <>
                <p>{intl.formatMessage({ id: 'fatca.provide' })}</p>
                <FormElementContainer isWithPadding isLightBg>
                  <Input
                    label={intl.formatMessage({ id: 'fatca.nameOfPerson' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.nameOfPerson' }).toLowerCase()}`}
                    name={`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`}
                    onInputChange={this.onElementChange}
                    value={q6NameOfPerson}
                    isValid={elementValidation[`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <SimpleSelectBox
                    label={intl.formatMessage({ id: 'fatca.nationality' })}
                    placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'fatca.nationality' }).toLowerCase()}`}
                    dataList={nationalities}
                    name={`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`}
                    onSelect={this.onHandleSelect}
                    defaultValue={q6Nationality}
                    isSearchInputDisabled={false}
                    isValid={elementValidation[`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <Textarea
                    label={intl.formatMessage({ id: 'fatca.detailedAddress' })}
                    placeholder={intl.formatMessage({ id: 'fatca.detailedAddress.placeholder' })}
                    name={`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`}
                    onInputChange={this.onElementChange}
                    value={q6Address}
                    isValid={elementValidation[`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                  <Input
                    label={intl.formatMessage({ id: 'fatca.phone' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'fatca.phone' }).toLowerCase()}`}
                    name={`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`}
                    onInputChange={this.onElementChange}
                    value={q6UsPhone}
                    isValid={elementValidation[`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`].isValid}
                    errorMessage={elementValidation[`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </>
            )}
          </section>
        )}
      </PaddedContainer>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  question1: selectors.getFatcaQ1(state),
  question2: selectors.getFatcaQ2(state),
  question3: selectors.getFatcaQ3(state),
  question4: selectors.getFatcaQ4(state),
  question5: selectors.getFatcaQ5(state),
  question6: selectors.getFatcaQ6(state),
  fatcaQ2state: selectors.getFatcaQ2State(state),
  fatcaQ2city: selectors.getFatcaQ2City(state),
  q3Address: selectors.getFatcaQ3Address(state),
  q3UsPhone: selectors.getFatcaQ3UsPhone(state),
  q4Address: selectors.getFatcaQ4Address(state),
  q5Beneficiary: selectors.getFatcaQ5Beneficiary(state),
  q5Nationality: selectors.getFatcaQ5Nationality(state),
  q6NameOfPerson: selectors.getFatcaQ6NameOfPerson(state),
  q6Nationality: selectors.getFatcaQ6Nationality(state),
  q6Address: selectors.getFatcaQ6Address(state),
  q6UsPhone: selectors.getFatcaQ6UsPhone(state),

  isSubmitClicked: selectors.getIsFormSubmitted(state),
});
const mapDispatchToProps = dispatch => ({
  onUpdateFatca: (name, value) => dispatch(fatcaCrsAction.updateFatca(name, value)),
  onClearQ2toQ6: () => dispatch(fatcaCrsAction.clearFatcaQ2Q6()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Fatca));
